export default __webpack_public_path__ + "static/media/telegram.988c4a88.png";